import React, { useEffect, useState } from "react";
import { Box, Heading, useToast, Button, HStack } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import RequestForm from "../components/RequestForm";
import procurementApi from "../services/procurementApi";

const RequestCreate = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [workflowOptions, setWorkflowOptions] = useState([]);

  useEffect(() => {
    fetchWorkflows();
  }, []);

  const fetchWorkflows = async () => {
    try {
      const response = await procurementApi.getWorkflows();
      setWorkflowOptions(response?.data || response || []);
    } catch (error) {
      setWorkflowOptions([]);
      toast({
        title: "Could not load workflows",
        description: error.response?.data?.message || error.message,
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      await procurementApi.createRequest(formData);
      toast({
        title: "Request created successfully",
        description: "Your procurement request has been saved as draft",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/procurement/requests");
    } catch (error) {
      toast({
        title: "Error creating request",
        description: error.response?.data?.message || error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/procurement/requests");
  };

  return (
    <Box p={6}>
      <HStack mb={6}>
        <Button
          leftIcon={<BsArrowLeft />}
          variant="ghost"
          onClick={handleCancel}
        >
          Back
        </Button>
        <Heading size="lg">Create Procurement Request</Heading>
      </HStack>
      <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
        <RequestForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={loading}
          workflowOptions={workflowOptions}
          showWorkflowSelect
        />
      </Box>
    </Box>
  );
};

export default RequestCreate;
